import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/top-up")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/top-up"!</div>;
}
